module.exports = __webpack_public_path__ + "static/img/nan-dou-liu-xing-yan-shou-deng.a849eb6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/nan-dou-liu-xing-yan-shou-deng.jpg
// module id = +D0l
// module chunks = 1